// @flow

import React from 'react';
import { message, Modal } from 'antd'
import { updateEstimate, updateEstimateItems, updateEstimateOptionals, updateEstimateCaveats } from '../../../HttpRequests/estimates';
import { setEditable } from '../State/editable';
import { setSelectedEstimateItemIds } from '../State/selectedEstimateItemIds';
import fetchEstimate from './fetchEstimate';
import handleException from '../../../Core/Helpers/handleException';
import selectEstimateTotals from '../Components/Footer/Selectors/selectEstimateTotals';

export default () => async (dispatch: Function, getState: Function) => {

  try {

    const state = getState();
    const { estimate } = state.screens.EstimateView;

    const { id } = estimate;

    // Validate that all estimate items have a type
    const itemsWithoutType = [];
    estimate.estimate_groups.forEach((group, groupIndex) => {
      group.estimate_items.forEach((item, itemIndex) => {
        // Check if type is missing, null, undefined, or empty string
        // Note: 'none' is a valid placeholder value
        if (!item.type || item.type === '' || item.type === null || item.type === undefined) {
          itemsWithoutType.push({
            groupName: group.name || `Group ${groupIndex + 1}`,
            lineNumber: item.line_number || (itemIndex + 1)
          });
        }
      });
    });

    if (itemsWithoutType.length > 0) {
      Modal.warning({
        title: 'Cannot Save Estimate',
        content: (
          <div>
            <p>The following items are missing a type:</p>
            {itemsWithoutType.map((item, index) => (
              <div key={index}>
                {`• Line ${item.lineNumber} in "${item.groupName}"`}
              </div>
            ))}
            <p style={{ marginTop: 12 }}>Please select a type for each item before saving.</p>
          </div>
        ),
        width: 500
      });
      return;
    }

    // Convert 'none' back to null before sending to backend
    const sanitizedEstimateGroups = estimate.estimate_groups.map(group => ({
      ...group,
      estimate_items: group.estimate_items.map(item => ({
        ...item,
        type: item.type === 'none' ? null : item.type
      }))
    }));

    // Update estimate items, optionals, and caveats
    await updateEstimateItems({ id, data: sanitizedEstimateGroups });

    await updateEstimateOptionals({ id, data: estimate.estimate_optionals });

    await updateEstimateCaveats({ id, data: estimate.estimate_caveats });

    // Calculate the CO2 total using the selector
    const estimateTotals = selectEstimateTotals(state);

    // Update the main estimate record with the CO2 total
    await updateEstimate({
      id,
      data: {
        co2_total: estimateTotals.co2Total.toFixed(2)
      }
    });

    console.log(`Saving estimate with CO2 total: ${estimateTotals.co2Total.toFixed(2)} kg`);

    dispatch(setEditable(false));

    dispatch(setSelectedEstimateItemIds([]));

    message.success("Estimate Updated");

    await dispatch(fetchEstimate());

  } catch (error) {

    handleException(error);

    throw error;

  }

}
